import getB from "../../utils/bridges/EkaBridge";

export const bulkGetPaitnets = async (oids: string[]) => {
  await getB().fetchPatientListFromServer(oids);
  return await getB().getPatientsByIds(oids);
};
    